<template>
  <v-breadcrumbs :items="breadcrumbItems" v-if="!hideBreadcrumbs" :class="{ 'dark-mode': isDarkMode }">
    <template v-slot:divider>
      <div class="divider-img">
        <v-img src="../../../assets/Images/breadcrumb-right-con.png" width="6" height="11"></v-img>
      </div>
    </template>
    <template v-slot:prepend>
      <div class="home-img">
        <v-img src="../../../assets/Images/House.png" class="cursor-pointer" width="20" height="20"
          @click="goToAssets"></v-img>
      </div>
      <div class="divider-img" v-if="isAssetsRoute">
        <v-img src="../../../assets/Images/breadcrumb-right-con.png" width="6" height="11"></v-img>
      </div>
    </template>
    <template v-slot:item="{ item, index }">
      <div class="text-capitalize test-text d-flex align-end"
        v-if="index === breadcrumbItems.length - 1 && !showTestsDropdown && item.title === 'Tests'">
        {{ item.title }}
        <v-icon width="16" height="16" @click="toggleTestsDropdown">mdi-chevron-down</v-icon>
      </div>
      <div class="text-capitalize test-text" v-else-if="showTestsDropdown && item.title === 'Tests'" ref="dropdownMenu">
        {{ item.title }}
        <v-icon width="16" height="16" @click="toggleTestsDropdown">mdi-chevron-up</v-icon>
        <div class="dropdown-menu" v-if="allTests.length > 0">
          <!-- Sample Validation Option -->
          <div class="test-name-div">
            <div class="breadcrumb-test-name" @click="openSampleValidationPage">
              Sample Validation
            </div>
          </div>
          <!-- Test Options -->
          <div class="test-name-div" v-for="(test, index) in allTests" :key="index">
            <div class="breadcrumb-test-name" @click="openTestPage(test, index)"
              :class="{ 'active': activeTestIndex === index }">
              <template v-if="test.testType === 'compositiontests'">
                <template v-if="test.contaminationType || test.recombinationType">
                  {{ getTestDisplayName(test.testType, test.index) }}({{ test.contaminationType ? test.contaminationType.charAt(0).toUpperCase() + test.contaminationType.slice(1) : '' }}{{ test.recombinationType ? ' ' + test.recombinationType.charAt(0).toUpperCase() + test.recombinationType.slice(1) : '' }})
                </template>
                <template v-else>{{ getTestDisplayName(test.testType, test.index) }}</template>
              </template>
              <template v-else>
                {{ getTestDisplayName(test.testType, test.index)}}
                <template v-if="test.testTemperature || test.testTemperature_UOM">
                  ({{ test.testTemperature }} {{ test.testTemperature_UOM }})
                </template>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="text-capitalize" v-else @click.native="item.title === 'Exploratory Data Analysis (EDA)' ? null : handleBreadcrumb(item.title)">
        <router-link v-if="item.title !== 'Exploratory Data Analysis (EDA)'" :to="{ path: item.href }">
          {{ item.title }}
        </router-link>
        <span v-else>
          {{ item.title }}
        </span>
      </div>
    </template>
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :timeout="snackbar.timeout">
      {{ snackbar.message }}
    </v-snackbar>
  </v-breadcrumbs>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "Links",
  data: () => ({
    items: [],
    currentURLSegments: [],
    showTestsDropdown: false,
    tenantId: localStorage.getItem("tenantId"),
    allTests: [],
    snackbar: {
      visible: false,
      message: "",
      color: "success",
      timeout: 3000,
    },
  }),
  computed: {
    ...mapGetters("test", ['activeTestIndex']),
    ...mapGetters("darkMode", ["isDarkMode"]),
    isAssetsRoute() {
      return this.$route.name !== 'Assets' && this.$route.name !== 'DataManagement' && this.$route.name !== 'FluidsDataStudio' && this.$route.name !== 'Main';
    },
    hideBreadcrumbs() {
      const pathSegments = this.$route.path.split('/').filter(Boolean); // Remove empty segments
      if (pathSegments.length < 2) return false; // Ensure there's a valid path after the tenant ID

      const routePath = `/${pathSegments.slice(1).join('/')}`.toLowerCase(); // Remove tenant ID and reconstruct path

      return routePath.includes('/dashboards') ||
        routePath.includes('/fluidsdata-studio') ||
        routePath.includes('/roles') ||
        routePath.includes('/users') ||
        routePath.includes('/fluidsintelligence') ||
        routePath.includes('/pvt-prediction');
    },

    breadcrumbItems() {
      const itemsCopy = this.items.slice();
      const pathSegments = this.$route.path.split('/').filter(Boolean); // Remove empty segments
      if (pathSegments.length < 2) return []; // Ensure there's a valid path after the tenant ID

      const tenantId = pathSegments[0]; // First segment is always the tenant ID
      const filteredSegments = pathSegments.slice(1); // Remove tenant ID from segments

      const assetParam = this.$route.params.asset;
      const fieldParam = this.$route.params.field;
      const wellParam = this.$route.params.well;
      const currentRoute = `/${filteredSegments.join('/')}`; // Rebuild path without tenant ID

      // Handle QA/QC routes
      if (currentRoute.includes("/qaqc")) {
        const testType = this.$route.params.testType;
        const testId = this.$route.params.testId;
        
        itemsCopy.push(
          {
            title: "QA/QC",
            href: `/${tenantId}/qaqc`
          }
        );
        
        if (currentRoute.includes("/qaqc/detail")) {
          itemsCopy.push({
            title: "Sample Details",
            href: `/${tenantId}/qaqc/detail`
          });
        } else if (testType) {
          itemsCopy.push(
            {
              title: "Sample Details",
              href: `/${tenantId}/qaqc/detail`
            },
            {
              title: "Tests",
              href: `/${tenantId}/qaqc/detail`
            },
            {
              title: testType.charAt(0).toUpperCase() + testType.slice(1),
              href: testId ? `/${tenantId}/qaqc/test/${testType}/${testId}` : `/${tenantId}/qaqc/test/${testType}`
            }
          );
        }
      }
      // Handle asset-based test routes
      else if (
        currentRoute.includes("/compositiontests") ||
        currentRoute.includes("/dltest") ||
        currentRoute.includes("/ccetest") ||
        currentRoute.includes("/cvdtest") ||
        currentRoute.includes("/separatortest") ||
        currentRoute.includes("/viscositytest") ||
        currentRoute.includes("/samplevalidation") ||
        currentRoute.includes("/sampleinformation")
        ) {
          itemsCopy.push(
            {
              title: assetParam ? `Asset: ${assetParam.replace(/\//g, '-').replace(/ /g, '-')}` : "Assets",
              href: `/${tenantId}/assets/${assetParam || ''}`
            },
            {
              title: fieldParam ? `Field: ${fieldParam.replace(/\//g, '-').replace(/ /g, '-')}` : "Fields",
              href: `/${tenantId}/assets/${assetParam || ''}/${fieldParam || ''}`
            },
            {
              title: wellParam ? `Well: ${wellParam.replace(/\//g, '-').replace(/ /g, '-')}` : "Wells",
              href: `/${tenantId}/assets/${assetParam || ''}/${fieldParam || ''}/${wellParam || ''}`
            },
            {
              title: "Samples",
              href: `/${tenantId}/assets/${assetParam || ''}/${fieldParam || ''}/${wellParam || ''}`
            },
            {
              title: "Tests",
              href: `/${tenantId}/assets/${assetParam || ''}/${fieldParam || ''}/${wellParam || ''}`
            }
          );
        } else if (wellParam) {
          itemsCopy.push(
            { title: `Asset: ${assetParam || "Assets"}`, href: `/${tenantId}/assets/${assetParam || ''}` },
            { title: `Field: ${fieldParam}`, href: `/${tenantId}/assets/${assetParam || ''}/${fieldParam || ''}` },
            { title: `Well: ${wellParam}`, href: `/${tenantId}/assets/${assetParam || ''}/${fieldParam || ''}/${wellParam || ''}` }
          );
        } else if (fieldParam) {
          itemsCopy.push(
            { title: `Asset: ${assetParam || "Assets"}`, href: `/${tenantId}/assets/${assetParam || ''}` },
            { title: `Field: ${fieldParam}`, href: `/${tenantId}/assets/${assetParam || ''}/${fieldParam || ''}` }
          );
        } else if (assetParam) {
          itemsCopy.push(
            { title: `Asset: ${assetParam || "Assets"}`, href: `/${tenantId}/assets/${assetParam || ''}` }
          );
        } else {
          let currentPath = `/${tenantId}`;
          itemsCopy.push(
            ...filteredSegments
              .filter(segment => !["assets", "data-management", "dashboards", "fluidsdata-studio"].includes(segment.toLowerCase())) 
              .map(segment => {
                currentPath += `/${segment.replace(/\//g, '-').replace(/ /g, '-')}`;
                let title = segment.replace(/-/g, ' ').charAt(0).toUpperCase() + segment.replace(/-/g, ' ').slice(1);

                if(title === "Exploratory Data Analysis" || title === "Exploratory-data-analysis")
                {
                  title = "Exploratory Data Analysis (EDA)";
                }
                else if(currentRoute.includes("/exploratory-data-analysis/inventory-analysis") && title !== "Exploratory-data-analysis") 
                {
                  title = "Inventory Analysis";
                }
                else if(currentRoute.includes("/exploratory-data-analysis/twodhistogram-kde"))
                {
                  title = "2D Histogram and Bivariate KDE";
                }
                else if(currentRoute.includes("/exploratory-data-analysis/correlation-analysis"))
                {
                  title = "Correlation Analysis";
                }
                else if(currentRoute.includes("/exploratory-data-analysis/statistical-analysis"))
                {
                  title = "Statistical Analysis";
                }
                else if(currentRoute.includes("/exploratory-data-analysis/3d-plot-analysis"))
                {
                  title = "3D Plot Analysis";
                }
                else if(currentRoute.includes("/exploratory-data-analysis/bubble-plot-analysis"))
                {
                  title = "Bubble Plot Analysis";
                }
                else if(currentRoute.includes("/exploratory-data-analysis/heatmap-analysis"))
                {
                  title = "Heatmap Analysis";
                }
                else if(currentRoute.includes("/exploratory-data-analysis/composition-gradient-analysis"))
                {
                  title = "Composition Gradient Analysis";
                }
                else if(title === "Qaqc" || title === "qaqc" || title === "QA QC")
                {
                  title = "QA/QC";
                }
                else if(currentRoute.includes("/qaqc/data-validation") && title !== "QA/QC") 
                {
                  title = "Data Validation";
                }
                else if(currentRoute.includes("/qaqc/quality-metrics") && title !== "QA/QC")
                {
                  title = "Quality Metrics";
                }
                else if(currentRoute.includes("/qaqc/compliance-check") && title !== "QA/QC")
                {
                  title = "Compliance Check";
                }
                else if(currentRoute.includes("/qaqc/qaqc-wells") && title !== "QA/QC")
                {
                  title = "Wells Overview";
                }
                else if(currentRoute.includes("/qaqc/detail") && title !== "QA/QC")
                {
                  title = "Detail";
                }
                
                return {
                  title,
                  href: currentPath,
                  icon: "mdi-chevron-down"
                };
              })
          );
        }
        return itemsCopy;
    },
    displayTestType() {
      return function (testType) {
        switch (testType) {
          case 'compositiontests':
            return 'Composition';
          case 'dltest':
            return 'DL';
          case 'ccetest':
            return 'CCE';
          case 'cvdtest':
            return 'CVD';
          case 'separatortest':
            return 'Separator Test';
          case 'viscositytest':
            return 'Viscosity';
          default:
            return testType;
        }
      }
    },
  },
  methods: {
    ...mapActions("test", ['setActiveTestIndex']),
    showSnackbar(message, color = "success") {
      this.snackbar.message = message;
      this.snackbar.color = color;
      this.snackbar.visible = true;
    },
         goToAssets() {
       const lastView = localStorage.getItem("activeMenu"); // Get 'lastView' from localStorage
       const urlSegments = window.location.pathname.split("/").filter(Boolean); // Get URL segments
       const tenantId = urlSegments.length > 0 ? urlSegments[0] : localStorage.getItem("tenantId"); // Extract tenant ID from URL or fallback to localStorage

       if (!tenantId) {
         console.error("Tenant ID is missing!");
         return;
       }

       // Check if lastView is 'data management'
       if (lastView && lastView.toLowerCase() === "data management") {
         this.$router.push(`/${tenantId}/data-management`); // Redirect to /{tenantId}/data-management
       }
       // Check if lastView is 'qa/qc'
       else if (lastView && lastView.toLowerCase() === "qa/qc") {
         this.$router.push(`/${tenantId}/qaqc`); // Redirect to /{tenantId}/qaqc
       }
       // Check if the first segment of the URL is 'assets'
       else if (urlSegments[1] && urlSegments[1].toLowerCase() === "assets") {
         this.$router.push(`/${tenantId}/assets`); // Redirect to /{tenantId}/assets
       }
       // Add additional redirection logic here if needed
     },
    updateBreadcrumbs() {
      const currentURL = window.location.pathname;
      this.currentURLSegments = currentURL
        .split("/")
        .filter((segment) => segment !== "");
      let updatedPath = `/${this.currentURLSegments.join("/")}`;
      updatedPath = updatedPath.replace(/\/$/, "");
      window.history.replaceState({}, "", updatedPath);
    },
    toggleTestsDropdown(event) {
      event.stopPropagation();
      this.showTestsDropdown = !this.showTestsDropdown;
    },
    showTests() {
      const pathSegments = this.$route.path.split('/').filter(Boolean);
      const tenantId = pathSegments[0] || '';
      this.allTests = [];
      const sampleId = localStorage.getItem("sampleId");
      axios
        .get(process.env.VUE_APP_API_URL + `public/api/samples/${sampleId}/tests`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            "X-TenantID": tenantId,
          },
        })
        .then((response) => {
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            const tests = response.data.data.allTests;

            const testGroups = {};
            tests.forEach(test => {
              if (!testGroups[test.testType]) {
                testGroups[test.testType] = [];
              }
              testGroups[test.testType].push(test);
            });

            Object.keys(testGroups).forEach(testType => {
              const group = testGroups[testType];
              if (group.length > 1) {
                group.forEach((test, index) => {
                  test.index = index + 1;  // Add numbering (1-based index)
                });
              }
            });

            this.allTests = [].concat(...Object.values(testGroups));
          }
          else if (response && response.data && response.data.message) {
            this.showSnackbar(response.data.message, "error");
          }
          else {
            this.showSnackbar("Error in fetching tests", "error");
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log("error");
          }
        });
    },

    getTestDisplayName(testType, index) {
      const testTypeDisplay = this.displayTestType(testType);
      return index ? `${testTypeDisplay} (Test #${index})` : testTypeDisplay;
    },

    openTestPage(test, index) {
      this.setActiveTestIndex(index);
      this.showTestsDropdown = false;

      const sampleId = localStorage.getItem("sampleId");
      const testId = test.ID;
      localStorage.setItem("sampleId", sampleId);
      localStorage.setItem("testId", testId);
      const testType = test.testType;

      // Extract tenant ID from the URL
      const pathSegments = this.$route.path.split('/').filter(Boolean);
      const tenantId = pathSegments[0] || ''; // First segment is always tenant ID

      // Check if we're in QA/QC context
      const currentRoute = `/${pathSegments.slice(1).join('/')}`;
      
      if (currentRoute.includes("/qaqc")) {
        // For QA/QC routes, navigate to QA/QC test page
        let newRoute = `/${tenantId}/qaqc/test/${testType}/${testId}`;
        localStorage.setItem("lastView", newRoute);
        this.$router.push(newRoute);
      } else {
        // For asset-based routes, use the original logic
        const routeParams = { ...this.$route.params };
        let newRoute = `/${tenantId}/assets/${routeParams.asset ? routeParams.asset.replace(/\//g, '-').replace(/ /g, '-') : ''}/${routeParams.field ? routeParams.field.replace(/\//g, '-').replace(/ /g, '-') : ''}/${routeParams.well ? routeParams.well.replace(/\//g, '-').replace(/ /g, '-') : ''}/${testType ? testType.replace(/\//g, '-').replace(/ /g, '-') : ''}/${testId ? testId.replace(/\//g, '-').replace(/ /g, '-') : ''}`;
        localStorage.setItem("lastView", newRoute);
        this.$router.push(newRoute);
      }
    },

    openSampleValidationPage() {
      this.showTestsDropdown = false;

      const sampleId = localStorage.getItem("sampleId");
      localStorage.setItem("sampleId", sampleId);

      // Extract tenant ID from the URL
      const pathSegments = this.$route.path.split('/').filter(Boolean);
      const tenantId = pathSegments[0] || ''; // First segment is always tenant ID

      // Check if we're in QA/QC context
      const currentRoute = `/${pathSegments.slice(1).join('/')}`;
      
      if (currentRoute.includes("/qaqc")) {
        // For QA/QC routes, navigate to QA/QC detail page
        let newRoute = `/${tenantId}/qaqc/detail`;
        localStorage.setItem("lastView", newRoute);
        this.$router.push(newRoute);
      } else {
        // For asset-based routes, use the original logic
        const routeParams = { ...this.$route.params };
        // Create route pattern: /tenantId/assets/asset/field/well/samplevalidation/sampleId
        let newRoute = `/${tenantId}/assets/${routeParams.asset ? routeParams.asset.replace(/\//g, '-').replace(/ /g, '-') : ''}/${routeParams.field ? routeParams.field.replace(/\//g, '-').replace(/ /g, '-') : ''}/${routeParams.well ? routeParams.well.replace(/\//g, '-').replace(/ /g, '-') : ''}/samplevalidation/${sampleId}`;
        localStorage.setItem("lastView", newRoute);
        this.$router.push(newRoute);
      }
    },
    closeDropdownMenuOnClickOutside(event) {
      if (this.showTestsDropdown) {
        if (this.$refs.dropdownMenu && !this.$refs.dropdownMenu.contains(event.target)) {
          this.showTestsDropdown = false;
        }
      }
    },
    handleBreadcrumb(title) {
      if (title === "Dashboards") {
        localStorage.removeItem("lastVisitedDashboard");
      } 
    }
  },
  watch: {
    $route(to, from) {
      this.updateBreadcrumbs();
    },
    breadcrumbItems: {
      handler(newItems, oldItems) {
        const containsTests = newItems.some(item => item.title === 'Tests');
        if (containsTests) {
          this.showTests();
        }
      },
      deep: true,
      immediate: true
    },
  },
  mounted() {
    document.body.addEventListener("click", this.closeDropdownMenuOnClickOutside);
    this.updateBreadcrumbs();
  },
  beforeUnmount() {
    document.body.removeEventListener("click", this.closeDropdownMenuOnClickOutside);
  },
};
</script>